"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.States = exports.Status = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A universal "Loading" model to indicate the state of a "View" or some
 * container.
 *
 * You can mutate the value prop directly or create a new instance merged
 * with the old like this
 *
 * var newState = new ViewState(oldState.value | States.LOADING)
 */
var States = {
  UNKNOWN: 0,
  NORMAL: 1,
  LOADING: 2,
  APPENDING: 4,
  PREPENDING: 8,
  EMPTY: 16,
  ERROR: 32
};
exports.States = States;

var Status = /*#__PURE__*/function () {
  function Status() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : States.UNKNOWN;

    _classCallCheck(this, Status);

    this.value = value;
  }

  _createClass(Status, [{
    key: "isUnknown",
    value: function isUnknown() {
      return this.value === 0;
    }
  }, {
    key: "isNormal",
    value: function isNormal() {
      return (this.value & States.NORMAL) !== 0;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return (this.value & States.LOADING) !== 0;
    }
  }, {
    key: "isAppending",
    value: function isAppending() {
      return (this.value & States.APPENDING) !== 0;
    }
  }, {
    key: "isPrepending",
    value: function isPrepending() {
      return (this.value & States.PREPENDING) !== 0;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return (this.value & States.EMPTY) !== 0;
    }
  }, {
    key: "hasError",
    value: function hasError() {
      return (this.value & States.ERROR) !== 0;
    }
  }, {
    key: "or",
    value: function or(state) {
      return new Status(this.value | state.value);
    }
  }, {
    key: "and",
    value: function and(state) {
      return new Status(this.value & state.value);
    }
  }]);

  return Status;
}();

exports.Status = Status;